import React from 'react';
import { CHECKOUT_URL } from '../data/pricing';
import { trackPixelEvent } from '../utils/metaPixel';

/** Ancla de la caja de oferta, a la altura del precio del producto. */
export const OFFER_ANCHOR_ID = 'oferta-precio';
interface CTAButtonProps {
  children?: React.ReactNode;
  className?: string;
  /**
   * 'offer'    — lleva a la caja de oferta, justo donde está el precio.
   * 'checkout' — lleva directo al pago (solo el botón de la caja de oferta).
   */
  to?: 'offer' | 'checkout';
}

/**
 * Único llamado a la acción de toda la página: mismo texto y mismo color
 * en las tres apariciones.
 */
export function CTAButton({
  children = 'Quiero el Pack Pilates Listo',
  className = '',
  to = 'offer'
}: CTAButtonProps) {
  const classes = 'inline-block text-center rounded-full font-bold uppercase tracking-wide text-white px-8 py-4 text-sm md:text-base shadow-md bg-brand-greenDark hover:bg-brand-greenDeep transition-[transform,box-shadow,background-color] duration-150 ease-smooth hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand-greenDark ' + className;
  if (to === 'offer') {
    return <a href={`#${OFFER_ANCHOR_ID}`} className={classes} data-id="element-41" data-mp="1i8terqiuh971">
        {children}
      </a>;
  }
  return <a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout', {
    content_name: 'Pilates Listo 360',
    currency: 'ARS',
    value: 19990
  })} className={classes} data-id="element-42" data-mp="1na8wb8ltcxko">
      {children}
    </a>;
}